import AddDMSConnectionModal, {
  IntegrationContent,
} from 'components/modals/AddDMSConnectionModal';
import React, { useState } from 'react';
import { ModalState } from 'records/ModalState';
import { truncateString } from 'utils/general';
import { useTranslator } from '@bluebeam/react-i18n';
import { product } from 'copy/copy';

type Props = {
  analyticsId: string;
  modalBanner: string;
  icon: string;
  content: IntegrationContent;
  getAuthUrl: () => Promise<string>;
};

const IntegrationsCard: React.FC<Props> = ({
  analyticsId,
  getAuthUrl,
  content,
  modalBanner = '',
  icon = '',
}: Props): React.ReactElement => {
  const [isModalOpen, setModalOpen] = useState<boolean>();

  const handleModalShow = () => {
    setModalOpen(!isModalOpen);
  };
  const { translate } = useTranslator(['integrationsPage']);

  const contentName: `${string}:${string}` =
    `integrationsPage:${content?.providerName}.text` as `${string}:${string}`;
  const translatedContent = translate(contentName, {
    product: product.productName,
    [content?.providerName]: content?.title,
  });

  const truncatedCopy = content ? truncateString(translatedContent, 90) : '';
  const assets = {
    banner: modalBanner,
    icon,
  };

  return (
    <>
      {isModalOpen && (
        <AddDMSConnectionModal
          analyticsId={analyticsId}
          assets={assets}
          getAuthUrl={getAuthUrl}
          content={content}
          onCancel={handleModalShow}
        />
      )}
      <div
        data-analytics={`${analyticsId}-card`}
        className="flex b-3 bgd-white-2 cursor-pointer"
        onClick={handleModalShow}
      >
        <div className="column">
          <img
            className="wrem-3p primary-blue ml3 mt3"
            src={icon}
            alt={`${content?.title} Icon`}
          />
        </div>
        <div className="column">
          <div className="primary-blue font-size-5 medium mt3 ml3">
            {content?.title}
          </div>
          <p className="color-gray-7 font-size-4 light mx3 my2">
            {truncatedCopy}
          </p>
          <div className="primary-blue font-size-4 light mx3 mb3">
            {translate('integrationsPage:integrationButtonText')}
          </div>
        </div>
      </div>
    </>
  );
};

export default IntegrationsCard;
